<div style="height: auto;">
    <!-- <div id="viewReportHeader">
        <h1 class="h1Style">{{showRiderName}}</h1>
    </div> -->
    <!-- <div style="display: flex; margin: 5px; margin-top: 1%;"> -->
        <!-- <div class="toggler-line-text-style">
            <b>Available To Take Order</b>
        </div> -->
        <!-- <div class="toggler-line-button-style">
            <mat-slide-toggle (change)="onChange($event)"
                [checked]="persistenceService.get('active_rider_status')=='true'"
                [disabled]="persistenceService.get('isVerified')!='true' && !this.riderDetails.isVerified"
                id="acceptOrder">
            </mat-slide-toggle>
        </div> -->
        <!-- <div style="width: 50%;margin-left: -10px;">
            <div class="toggler-line-button-style">
                <mat-slide-toggle (change)="onChange($event)" [checked]="persistenceService.get('active_rider_status') == 'true'" [disabled]="persistenceService.get('isVerified') != 'true'" id="acceptOrder">
                </mat-slide-toggle>
            </div>
        </div>

        <div style="width: 50%; display: flex; justify-content: end;">
            <mat-icon style="font-size: 26px !important; padding-right: 30px;" (click)="notificationClicked()">notifications_none</mat-icon>
        </div>
    </div> -->

    <div style="display: flex;">
        <div type="button" style="margin-left: 2px;" (click)="divClick('Daily',toDate,toDate)" id="daily" class="btn btn-secondary btn-sm">Daily</div>
        <div type="button" style="margin-left: 2px;" (click)="divClick('Weekly',firstDayOfWeek,toDate)" id="weekly" class="btn btn-secondary btn-sm">Weekly</div>
        <div type="button" style="margin-left: 2px;" (click)="divClick('Monthly',fromDate,toDate)" id="monthly" class="btn btn-secondary btn-sm">Monthly</div>
    </div>
    <div style="padding-top: 3px;">
        <mat-card class="contain_card">
            <mat-form-field class="selectOption">
                <mat-select placeholder="Date Range" (selectionChange)="onFilterSelect($event.value)" [(value)]="selectedValue">
                    <mat-option *ngFor="let type of filterData " [value]="type ">
                        {{type}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-card>
    </div>
    <div style="padding-top: 3px;">
        <table style="margin-top: 1%; ">
            <tr style="height: 30px;">
                <th style="background: #252e34b5; color: #fff; padding-left: 5px; font-size: 13px !important; text-align: left !important; " id="chartHead">
                    Date Range Wise Total Earnings</th>
            </tr>
            <tr>
                <td>
                    <google-chart [type]=" 'ColumnChart' " [data]="chartData " [width]="widthOrderTrendLine " [height]="heightOrderTrendLine " [options]="legendTypeFull ">
                    </google-chart>
                </td>
            </tr>
        </table>
    </div>
    <div style="max-width: 100%; padding: 0px 10px;">
        <p style="margin-top: 10px;padding-left: 2px;"><b id="performanceHead">Today's performance</b></p>

        <table style="border-radius: 5px;">
            <!-- <tr>
                <th style="background: #252e34b5; color: #fff; padding-left: 5px; font-size: 12px !important; text-align: left !important; " colspan="3 ">Order Summary</th>
            </tr> -->
            <tr>
                <th style="color: rgb(44, 42, 42); background-color: initial;width: 50%!important;font-size: small; border-radius: 5px 0px 0px 5px; border: none !important;">{{totalQty}}<br>
                    <p style="font: .6em sans-serif"> Trips</p>
                </th>
                <th style="color: rgb(40, 36, 36); background-color: initial;width: 50%!important;font-size:x-small; border: none !important; border-radius: 0px 5px 5px 0px;">{{timeSpent/60/60 | number : '1.2-2'}} Hour(s)<br>
                    <p style="font: .6em sans-serif"> Time Spent</p>
                </th>
            </tr>

            <!-- <tr>
                <td><b style="font-size: 90%; ">{{totalQty}}</b></td>
                <td><b style="font-size: 90%; ">{{totalAmount | number : '1.2-2'}}</b></td>
            </tr> -->
        </table>
    </div>
    <div style="display: flex; padding-left: 2px; font-size: medium; padding-top: 8px; padding-bottom: 8px; margin: 10px 8px; border-radius: 5px; border: 1px solid #cdcccc;">
        <div style="width: 70%;">
            <b id="totEarning"> Total Earnings for today</b>
        </div>
        <div style="text-align: center;width: 30%;">
            <b>{{totalAmount | number : '1.2-2'}}</b>
        </div>

    </div>
    <div style="height: 50px;padding-left: 2px;">
        <p style="margin-top: 10px;font: .7em sans-serif;margin-top: 40px;">&nbsp;* Settlement will be done at the end of the week</p>
    </div>
</div>